export interface IApiResponse {
    message?: string[];
    data?: any;
    status?: any;
}

class ApiResponse implements IApiResponse {
    readonly data?: any;
    readonly message?: string[];
    readonly status?: any;

    constructor(message?: string[], data?: any, status?: any) {
        this.message = message;
        this.data = data;
        this.status = status;
    }
}

export default ApiResponse;